import * as types from './actionTypes'
import { notificationsPagination } from '../../utils/constants'

export const initialState = {
  notifications: [],
  hasMore: true,
}

const Notifications = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_NOTIFICATIONS:
      return {
        notifications: [...state.notifications, ...payload],
        hasMore: payload.length >= notificationsPagination,
      }
    default:
      return state
  }
}

export default Notifications
